export const handleTypes = (
  type,
  gFirstValue,
  generalCondition,
  toDelete,
  data,
  groupedData,
) => {
  if (type === 'single') {
    return handleSingleType(gFirstValue, generalCondition, toDelete, data);
  } else {
    return handleCustomType(
      gFirstValue,
      generalCondition,
      toDelete,
      groupedData,
    );
  }
}

function handleSingleType(gFirstValue, generalCondition, toDelete, mainData) {
  gFirstValue["m"] ="and";

  mainData.forEach(({ input, operator, compareTo }) => {
    const inputWithOperator = `${input}_${operator}`;

    if (gFirstValue[inputWithOperator] && !operator.includes("null")) {
      const op = handleGeneralCondition(generalCondition, operator);
      const inputWithOp = `${input}_${op}`;
      toDelete = toDelete.concat(inputWithOperator);
      gFirstValue[inputWithOp] = handleInputWithOp(
        gFirstValue[inputWithOp],
        gFirstValue[inputWithOperator],
        compareTo,
      );
    } else {
      gFirstValue[inputWithOperator] = compareTo;
    }
  });
  
  deleteRowValue(toDelete, gFirstValue);
}

function handleCustomType(gFirstValue, generalCondition, toDelete, mainData) {
  gFirstValue["g"] = [];
  mainData?.forEach(({ data: dataGroup, group }) => {
    gFirstValue["m"] = "and";
    gFirstValue["g"].push({ m: "" });
    gFirstValue["g"][group]["m"] = generalCondition;
    dataGroup.forEach(({ input, operator, compareTo }) => {
      let inputWithOperator = '';
      if (input === 'responsible_name_or_responsible_last_name' && ['not_cont', 'not_eq'].includes(operator) ) {
        inputWithOperator = `responsible_name_and_responsible_last_name_${operator}`;
      } else {
        inputWithOperator = `${input}_${operator}`;
      }

      const groupInputOperator = gFirstValue["g"][group][inputWithOperator];
      if (groupInputOperator) {
        const op = handleGeneralCondition(generalCondition, operator);
        const inputWithOp = `${input}_${op}`;
        toDelete.push(inputWithOperator);
        gFirstValue["g"][group][inputWithOp] = handleInputWithOp(
          gFirstValue["g"][group][inputWithOp],
          groupInputOperator,
          compareTo,
        );
      } else {
        gFirstValue["g"][group][inputWithOperator] = compareTo;
      }
    });
    deleteRowValue(toDelete, gFirstValue["g"][group]);
  });
}

function handleInputWithOp(inputWithOp, inputWithOperator, compareTo) {
  return Array.isArray(inputWithOp)
    ? inputWithOp.concat(compareTo)
    : [inputWithOperator, compareTo];
}

function handleGeneralCondition(generalCondition, operator) {
  return generalCondition === "and" ? `${operator}_all` : `${operator}_any`;
}

function deleteRowValue(deleteData, value) {
  deleteData?.forEach((row) => {
    delete value[row];
  });
}